/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { DateTime } from '@app/shared/models/date-time.model';
import { User } from '@app/settings/users/user.model';

export interface CheckInOutInterval {
  check_in_at: string;
  check_out_at: string | null;
  minutes: number | null;
  missing_check_out?: boolean;
  original_check_in_at?: string | null;
  original_check_out_at?: string | null;
  edited_at?: string | null;
  edited_by_user_id?: number | null;
  edited_by_user_name?: string | null;
  edit_note?: string | null;
  resolved_by_user_id?: number | null;
  resolution_note?: string | null;
}

export class CheckInOut extends Model {
  id: number;
  user_id: number;
  user?: User;
  work_date: string;
  total_minutes: number;
  current_total_minutes: number;
  first_check_in_at?: DateTime;
  last_check_out_at?: DateTime;
  open_interval_started_at?: DateTime;
  intervals: Array<CheckInOutInterval> = [];
  resolution_note?: string;
  resolved_by_user_id?: number;
  resolved_by?: User;
  is_open = false;
  is_blocked = false;
  has_missing_check_out = false;
  required_minutes = 460;
  is_under_required_time = false;
  needs_attention = false;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.user) {
      this.user = new User().deserialize(input.user);
    }

    if (input.resolved_by) {
      this.resolved_by = new User().deserialize(input.resolved_by);
    }

    if (input.first_check_in_at) {
      this.first_check_in_at = new DateTime().deserialize(input.first_check_in_at);
    }

    if (input.last_check_out_at) {
      this.last_check_out_at = new DateTime().deserialize(input.last_check_out_at);
    }

    if (input.open_interval_started_at) {
      this.open_interval_started_at = new DateTime().deserialize(input.open_interval_started_at);
    }

    this.intervals = input.intervals || [];
    return this;
  }

  get formattedRequiredTime(): string {
    const hours = Math.floor(this.required_minutes / 60);
    const minutes = this.required_minutes % 60;
    return `${hours}h ${minutes}m`;
  }
}
